import { getRequest, patchRequest, postRequest } from '@helpers/api';
import { keysToSnake } from '@helpers/camelCaseConverter';

/**
 * Gets tax codes
 * @returns {Promise<*>}
 */
export const getTaxCodes = () => getRequest(`vFile/vgTransactionType/`, { limit: 10000 });

/**
 * Get tax codes rates
 * @param {string} jurisdiction - country unique identifier
 * @returns {Promise<*>}
 */
export const getTaxCodesRates = jurisdiction => getRequest(`countries/vatRate/${jurisdiction}/`);

/**
 * Get tax codes transaction types
 * @param {Object} $0 - payload
 * @param {string|undefined} [$0.entityJurisdictionId] - entity jurisdiction unique identifier
 * @returns {Promise<*>}
 */
export const getTaxCodesTransactionTypes = ({ entityJurisdictionId } = {}) =>
  getRequest(`vFile/clientTransactionType/`, { entity_jurisdiction: entityJurisdictionId });

/**
 * Save client tax codes
 * @param {Object} $0 - payload
 * @param {{client_transaction_types: Array<{vg_transaction_type: string, name: string}>, entity_jurisdictions: Array<string>}} taxCodesData - tax codes updated data
 * @param {boolean} view - is view mode?
 * @returns {Promise<unknown | void>}
 */
export const saveClientTaxCodes = ({ taxCodesData, view }) => {
  const requestArgs = ['vFile/clientTransactionTypeMultiple/', keysToSnake(taxCodesData)];

  return view ? patchRequest(...requestArgs) : postRequest(...requestArgs);
};
